import { Box, Typography, SvgIcon, Stack, Divider } from "@mui/material"
import { MAX_SYMPTOMS } from "config/constants"

import { ReactComponent as DangerIcon } from "static/svg/alerts/danger.svg"
import { ReactComponent as MediumIcon } from "static/svg/alerts/medium.svg"

import useTranslation from "../../../hooks/use_translation"
import DangerCard from "../../shared/symptoms/DangerCard"
import WarningCard from "../../shared/symptoms/WarningCard"
import NormalCard from "../../shared/symptoms/NormalCard"

const Symptoms = ({ data }) => {
  const priorityOrder = { high: 1, medium: 2, low: 3 }
  const { anamnesis } = useTranslation()

  const sortedData = data
    .slice(0, MAX_SYMPTOMS)
    .sort((a, b) => priorityOrder[a.danger] - priorityOrder[b.danger])

  const getSymptomCard = (item) => {
    if (item?.danger === "high") {
      return <DangerCard item={item} size="normal" />
    } else if (item?.danger === "medium") {
      return <WarningCard item={item} size="normal" />
    } else {
      return <NormalCard item={item} size="normal" />
    }
  }

  if (data.length === 0) return

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: "26px" }}>
        {anamnesis?.result_symptoms_title}
      </Typography>
      <Typography
        variant="caption"
        component="p"
        sx={{ fontWeight: 400, my: 1, lineHeight: "16px" }}
      >
        {anamnesis?.result_symptoms_subtitle}
      </Typography>

      <Stack direction="row" columnGap={3}>
        <Box sx={{ display: "flex", alignContent: "baseline" }}>
          <SvgIcon component={DangerIcon} inheritViewBox sx={{ width: 18, height: 18 }} />
          <Typography variant="caption" sx={{ ml: 1 }}>
            {anamnesis?.symptoms_high_risk}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignContent: "baseline" }}>
          <SvgIcon component={MediumIcon} inheritViewBox sx={{ width: 18, height: 18 }} />
          <Typography variant="caption" sx={{ ml: 1 }}>
            {anamnesis?.symptoms_medium_risk}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignContent: "baseline" }}>
          <Box sx={{ width: 18, height: 18, backgroundColor: "#fff", borderRadius: 10 }} />
          <Typography variant="caption" sx={{ ml: 1 }}>
            {anamnesis?.symptoms_low_risk}
          </Typography>
        </Box>
      </Stack>

      <Divider sx={{ mt: 1, mb: 2 }} />

      <Stack direction="column" spacing={1.5}>
        {sortedData.map((item, i) => (
          <Box key={i}>{getSymptomCard(item)}</Box>
        ))}
      </Stack>
    </Box>
  )
}

export default Symptoms
